module.exports = __webpack_public_path__ + "static/media/25.f74f8730.jpg";